/** Badge styling for Phase 1 search-engine origin tags on projects. */

export function discoverySourceTagClass(label: string): string {
  const key = label.trim().toLowerCase();
  if (key.includes("brave keyword")) {
    return "bg-primary/10 text-primary border-primary/20";
  }
  if (key.includes("llm context")) {
    return "bg-tertiary/10 text-tertiary border-tertiary/20";
  }
  if (key.includes("openrouter pro")) {
    return "bg-secondary/10 text-secondary border-secondary/20";
  }
  if (key.includes("openrouter cheap")) {
    return "bg-secondary/10 text-secondary/80 border-secondary/20";
  }
  return "bg-surface-container-high text-on-surface-variant border-outline-variant";
}
